export const morseCodeAlphabet: Record<string, string> = {
  '-----': '0',
  '.----': '1',
  '..---': '2',
  '...--': '3',
  '....-': '4',
  '.....': '5',
  '-....': '6',
  '--...': '7',
  '---..': '8',
  '----.': '9',
  '.-': 'A',
  '-...': 'B',
  '-.-.': 'C',
  '-..': 'D',
  '.': 'E',
  '..-.': 'F',
  '--.': 'G',
  '....': 'H',
  '..': 'I',
  '.---': 'J',
  '-.-': 'K',
  '.-..': 'L',
  '--': 'M',
  '-.': 'N',
  '---': 'O',
  '.--.': 'P',
  '--.-': 'Q',
  '.-.': 'R',
  '...': 'S',
  '-': 'T',
  '..-': 'U',
  '...-': 'V',
  '.--': 'W',
  '-..-': 'X',
  '-.--': 'Y',
  '--..': 'Z',
  '.-.-.-': '.',
  '--..--': ',',
  '..--..': '?',
  '-.-.--': '!',
  '-....-': '-',
  '-..-.': '/',
  '.--.-.': '@',
  '-.--.': '(',
  '-.--.-': ')',
};

export const morseTimes = {
  dot: 0,
  dash: 375,
  codeEndDelay: 1750,
};
